const environment = {
  enableReduxDevTool: true,
  b2bDomain: 'https://business.dev.karcher.com',
  loginUrl: 'https://login-dev.app.kaercher.com',
  baseUrl: 'https://api-dev.business.karcher.com',
  shopFAPIUrl: 'https://shop-fapi.api.business.dev.karcher.com/api',
  adminFAPIUrl: 'https://admin-fapi.api.business.dev.karcher.com/api',
  serviceFAPIUrl: 'https://service-fapi.api.business.dev.karcher.com/api',
  aws: {
    cognito: {
      userPoolId: 'eu-central-1_Trws0c7YS',
      oauthDomain: 'ak-b2bec-dev-users.auth.eu-central-1.amazoncognito.com',
      clientId: '5c4vcadgbsq8io6or11i4etlsf',
      region: 'eu-central-1',
      identityProvider: {
        customers: 'b2b-ec-customer',
        employees: 'b2b-ec-employee',
      },
    },
  },
}

export default environment
